import { useTenantStore } from '@/store/tenantStore';
import { useLocalization } from '@/hooks/useLocalization';
import styles from '../AuthPage.module.css';

/**
 * SupportWarningDialog — an error message followed by the tenant's support email as a
 * mailto link, with an OK button. It can't be dismissed by tapping outside.
 *
 * Mirrors Flutter CustomDialog.showErrorAndSupportWarningDialog (custom_dialog.dart), used
 * when Firebase rejects a password on sign up / reset ("password-does-not-meet-requirements").
 * The support email is Constants.supportEmailId (contentSettings.deleteAccountContent.emailId).
 */

interface SupportWarningDialogProps {
  /** Flutter's (untranslated) message */
  message: string;
  onOk: () => void;
}

export function SupportWarningDialog({ message, onOk }: SupportWarningDialogProps) {
  const { t } = useLocalization();
  const { content } = useTenantStore();
  const supportEmail = content?.contentSettings?.deleteAccountContent?.emailId ?? '';

  return (
    <div className={styles.dialogOverlay}>
      <div className={`${styles.dialogContent} ${styles.dialogCentered}`} role="alertdialog" aria-modal="true">
        <p className={styles.dialogMessage}>
          {t(message)}
          {supportEmail && (
            <>
              {' '}
              <a className={styles.supportLink} href={`mailto:${supportEmail}`}>{supportEmail}.</a>
            </>
          )}
        </p>
        <button type="button" className={`${styles.primaryBtn} ${styles.dialogBtn}`} onClick={onOk} autoFocus>
          {t('OK')}
        </button>
      </div>
    </div>
  );
}
